export default __webpack_public_path__ + "static/media/car-parts.9e5d2dc5.svg";